module.exports = __webpack_public_path__ + "static/img/bg1.0e82090.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app/login/bg1.jpg
// module id = 60
// module chunks = 0